import React from 'react';
import { motion } from 'framer-motion';
import { FiFacebook, FiLinkedin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/ClarkRitchotte/',
      icon: FiFacebook
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/clarkritchotte/',
      icon: FiLinkedin
    }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="col-span-1 md:col-span-2"
          >
            <h3 className="text-xl font-bold text-white mb-4">Hudson Valley Business Internet</h3>
            <p className="text-gray-400 mb-4">
              Your trusted partner for reliable business internet solutions in the Hudson Valley. 
              We help businesses find the perfect connectivity options to power their growth.
            </p>
            <div className="flex space-x-4 mb-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                  aria-label={social.name}
                >
                  <SafeIcon icon={social.icon} className="w-6 h-6" />
                </a>
              ))}
            </div>
            <div className="text-sm text-gray-500">
              <p>200 Broadway, Floor 3</p>
              <p>New York, NY 10038</p>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="hover:text-white transition-colors">Our Services</a></li>
              <li><a href="#about" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#testimonials" className="hover:text-white transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="text-lg font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="hover:text-white transition-colors">Fiber Internet</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Cable Internet</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Fixed Wireless</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Managed Services</a></li>
            </ul>
          </motion.div>
        </div>

        {/* Service Areas */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-12 pt-8 border-t border-gray-800"
        >
          <h4 className="text-lg font-semibold text-white mb-4">Service Areas</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 text-sm">
            <span>Poughkeepsie</span>
            <span>Kingston</span>
            <span>Newburgh</span>
            <span>Middletown</span>
            <span>Beacon</span>
            <span>Fishkill</span>
            <span>Wappingers</span>
            <span>LaGrange</span>
            <span>Rhinebeck</span>
            <span>Hyde Park</span>
            <span>Pleasant Valley</span>
            <span>Red Hook</span>
          </div>
        </motion.div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center"
        >
          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} Hudson Valley Business Internet. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a 
              href="https://corporate.clarkritchotte.com/legal/privacy/" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Privacy Policy
            </a>
            <a 
              href="https://corporate.clarkritchotte.com/legal/tos/" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-white transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;